import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=568e8c5e&scoped=true&"
import script from "./CustomerList.vue?vue&type=script&lang=js&"
export * from "./CustomerList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=568e8c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e8c5e",
  null
  
)

export default component.exports